module.exports = __webpack_public_path__ + "media/images/talent/lp/ambassador/feature02-bfcced987432e02eefb4a99f90dce681.png";